export default __webpack_public_path__ + "static/media/splashBase.c21f769a.svg";